// @ts-nocheck

import React, { useContext, useCallback, useEffect } from "react";

import SingleFileComponent from "./SingleFile";
import { SingleFileProps } from "./SingleFile.props";
import styles from "./SingleFile.module.scss";
import Icon from "../../../../brand/Icon";

import FieldMessage from "../../FieldMessage";

import { FormContext, useWatch } from "../../../Form";

const SingleFile: React.FC<SingleFileProps> = (props: SingleFileProps): JSX.Element => {
  const { id, name, labelPosition = "top", helperText, isLoading, resetForm } = props;
  const { control, formState, setValue } = useContext(FormContext);
  const { errors } = formState;
  const { isFormLoading } = formState;

  const files: File[] = useWatch({ name, control });
  const isInvalid = errors ? Object.keys(errors)?.length && errors[name] : false;

  const handleDeleteClick = useCallback((): void => {
    setValue && setValue(name, null);
  }, [setValue]);

  let fileDisplay = null;
  if (files && files.length !== 0) {
    fileDisplay = (
      <div className={styles["saved-file"]} data-testdata={`test__${id}saved-file`}>
        <div className={styles["file-list-title"]}>File Name</div>
        <div className={styles["file-list-item-group"]}>
          <span id={`fileName`} className={styles["file-name-text"]}>
            {files[0].name}
          </span>
          <button
            type="button"
            id={"delete-0"}
            className={styles["file-delete-btn"]}
            onClick={handleDeleteClick}
            data-testid={`test__${id}-delete-btn`}
          >
            <Icon id={`file-delete-icon`} name="trash" size="small" color="red" />
          </button>
        </div>

        {/* @ts-ignore */}
        {isInvalid ? <div className={styles["error-message"]}>{errors}</div> : ""}
      </div>
    );
  }

  useEffect(() => {
    if (resetForm) {
      fileDisplay = null;
    }
  }, [resetForm]);

  return (
    <div className={styles["single-file-upload-wrapper"]} data-testid={`test__${id}`}>
      <SingleFileComponent {...props} resetForm={resetForm} />
      {labelPosition === "left" && Boolean(files?.length) && <hr className={styles["file-upload-seperator"]} />}
      <div className={styles["file-list-wrapper"]}>
        <FieldMessage id={id} helperText={helperText} errors={errors} name={name} isLoading={isLoading || isFormLoading} />
        <div className={styles["file-list"]}>{fileDisplay}</div>
      </div>
    </div>
  );
};

export default SingleFile;
